const QUERIES = {
  USERS_LIST: 'permissions-list',
}

export {QUERIES}
